module.exports = __webpack_public_path__ + "static/media/basic-attention-token.80162b33.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/basic-attention-token.svg
// module id = 1142
// module chunks = 0